import styled from 'styled-components';
import CardForm from 'components/creditCard/Form/components/CardForm/container';

export default styled(CardForm)``;
